// utils/formatCurrency.js
const formatCurrency = (value) => {
  if (isNaN(value)) return 'N/A';
  return value
    ?.toFixed(2) // always 2 decimal places
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, ','); // add commas
};

export default formatCurrency;
